export const VERIFY_CUSTOMER_SUBSCRIPTION = "SETTINGS/VERIFY_CUSTOMER_SUBSCRIPTION";
export const VERIFY_CUSTOMER_SUBSCRIPTION_SUCCESS = "SETTINGS/VERIFY_CUSTOMER_SUBSCRIPTION_SUCCESS";
export const VERIFY_CUSTOMER_SUBSCRIPTION_FAILURE = "SETTINGS/VERIFY_CUSTOMER_SUBSCRIPTION_FAILURE";

export const RESET_CUSTOMER_SUBSCRIPTION_VERIFIED = "SETTINGS/RESET_CUSTOMER_SUBSCRIPTION_VERIFIED";
